//@flow

// Vendors
import React from 'react';
import { Switch, Route } from 'react-router-dom';

// Components
import { PrivateRoute } from '../components';

// Pages
import getPages from '../pages';
import CDLLRConfirmDetails from '../pages/apps/DLR/DLRLR/DLRLRSteps/CDLLRConfirmDetails/CDLLRConfirmDetails';
import PAGE_TYPES from '../pages/pageTypes';

const {
  BNLRPage,
  BNLREligibilityRequirements,
  DLRLRPage,
  TDLRLRPage,
  DMVRRPage,
  TPWDASPage,
  DMVStickerTracker,
  LinkServicePage,
  CybersecurityPage,
  NoMatchPage,
  DLRLRAddressUpdate,
  DPSUpdateEmergencyContactsPage,
  DPSUpdateEmergencyContactsReceipt,
  ConfirmCardPage,
  EditRenewalNotice,
  ReverifyPage,
} = getPages(PAGE_TYPES.TAKEOVER);
const RoutesTakeover = () => {
  return (
    <Switch>
      <PrivateRoute path="/link" component={LinkServicePage} />
      <PrivateRoute
        path="/dmv/edit-renewal-notice"
        component={EditRenewalNotice}
      />
      <PrivateRoute
        exact
        path="/bnlr/eligibility-requirements"
        component={BNLREligibilityRequirements}
      />
      <PrivateRoute path="/bnlr" component={BNLRPage} />

      <PrivateRoute
        path="/dpslr/addressUpdate"
        component={DLRLRAddressUpdate}
      />

      <PrivateRoute
        path="/dpslr/confirmDetails"
        component={CDLLRConfirmDetails}
      />

      <PrivateRoute
        path="/dpslr/emergencyContacts/success"
        component={DPSUpdateEmergencyContactsReceipt}
      />
      <PrivateRoute
        path="/dpslr/emergencyContacts"
        component={DPSUpdateEmergencyContactsPage}
      />

      <PrivateRoute path="/dpslr/confirmCard" component={ConfirmCardPage} />

      <PrivateRoute path="/dpslr" component={DLRLRPage} />
      <PrivateRoute path="/tdlrlr" component={TDLRLRPage} />
      <PrivateRoute path="/dmvrr" component={DMVRRPage} />
      <PrivateRoute path="/dmv/sticker-tracker" component={DMVStickerTracker} />
      <PrivateRoute path="/tpwdas" component={TPWDASPage} />
      <PrivateRoute path="/cybersecurity" component={CybersecurityPage} />
      <PrivateRoute path="/reverify" component={ReverifyPage} />
      <Route component={NoMatchPage} />
    </Switch>
  );
};

export default RoutesTakeover;
